import React from 'react';
import Layout from '../../layout/Layout';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const BecomePartner = (props) => {
  const initialValues = {
    companyName: "",
    representativeName: "",
    position: "",
    email: "",
    phone: "",
    website: "",
    sector: "",
    creationYear: "",
    employees: "",
    headquarters: "",
    description: "",
    partnershipReason: "",
    collaborationTypes: [],
    previousCollaborations: "",
    projects: "",
  };

  const validationSchema = Yup.object({
    companyName: Yup.string().required("Le nom de l'entreprise est requis"),
    representativeName: Yup.string().required("Le nom du représentant est requis"),
    position: Yup.string().required("Le poste est requis"),
    email: Yup.string().email("Email invalide").required("L'email est requis"),
    phone: Yup.string().required("Le numéro de téléphone est requis"),
    website: Yup.string().url("URL invalide"),
    sector: Yup.string().required("Le secteur d'activité est requis"),
    creationYear: Yup.number()
      .min(1900, "Année invalide")
      .max(new Date().getFullYear(), "Année invalide")
      .required("L'année de création est requise"),
    employees: Yup.number()
      .min(1, "Nombre invalide")
      .required("Le nombre d'employés est requis"),
    headquarters: Yup.string().required("Le siège social est requis"),
    description: Yup.string().max(500, "La description est trop longue"),
    partnershipReason: Yup.string().required("Ce champ est requis"),
    collaborationTypes: Yup.array().min(1, "Sélectionnez au moins une option"),
  });

  const handleSubmit = (values) => {
    console.log("Form data", values);
  };

  return (
    <Layout>
      <section className="bg-dark pt-lg-8">
        <div className=" container pt-4 pt-lg-0" data-bs-theme="dark">
          <div className=" row align-items-center mb-7">
            <div className="col-xl-6">
              <h1 className="display-5">Highlights of cases that we've built</h1>
            </div>
            <div className="col-xl-5 ms-auto">
              <p className="mb-4">The combination of my passion for design, code & interaction positions
                me in a unique place in the web design world.</p>
              <div className="text-center d-inline-block bg-light border rounded px-5 py-3">
                <span className="heading-color">Work with us?</span> <a className="ms-2"
                                                                        href="contact-v2.html">Contact
                us now<span className="bi-chevron-right small ms-1"></span></a>
              </div>
            </div>
          </div>


        </div>
      </section>

      <section className="row" >
          <div className="offset-lg-4 col-lg-4" style={{position : 'relative', top : "-200px"}}>
           <div className="card">
             <div className="card-body">
               <Formik
                 initialValues={initialValues}
                 validationSchema={validationSchema}
                 onSubmit={handleSubmit}
               >
                 {({ isSubmitting }) => (
                   <Form className="container mt-5">
                     <div className="mb-3">
                       <label className="form-label">Nom de l'Entreprise :</label>
                       <Field type="text" name="companyName" className="form-control" />
                       <ErrorMessage name="companyName" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Nom du Représentant :</label>
                       <Field type="text" name="representativeName" className="form-control" />
                       <ErrorMessage name="representativeName" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Poste :</label>
                       <Field type="text" name="position" className="form-control" />
                       <ErrorMessage name="position" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Email :</label>
                       <Field type="email" name="email" className="form-control" />
                       <ErrorMessage name="email" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Numéro de Téléphone :</label>
                       <Field type="text" name="phone" className="form-control" />
                       <ErrorMessage name="phone" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Site Web :</label>
                       <Field type="text" name="website" className="form-control" />
                       <ErrorMessage name="website" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Secteur d'Activité :</label>
                       <Field type="text" name="sector" className="form-control" />
                       <ErrorMessage name="sector" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Année de Création :</label>
                       <Field type="number" name="creationYear" className="form-control" />
                       <ErrorMessage name="creationYear" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Nombre d'Employés :</label>
                       <Field type="number" name="employees" className="form-control" />
                       <ErrorMessage name="employees" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Siège Social :</label>
                       <Field type="text" name="headquarters" className="form-control" />
                       <ErrorMessage name="headquarters" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Description Brève :</label>
                       <Field as="textarea" name="description" className="form-control" />
                       <ErrorMessage name="description" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Pourquoi souhaitez-vous devenir partenaire ?</label>
                       <Field as="textarea" name="partnershipReason" className="form-control" />
                       <ErrorMessage name="partnershipReason" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Types de Collaboration :</label>
                       <div className="form-check">
                         <Field type="checkbox" name="collaborationTypes" value="Sponsoring" className="form-check-input" />
                         <label className="form-check-label">Sponsoring</label>
                       </div>
                       <div className="form-check">
                         <Field type="checkbox" name="collaborationTypes" value="Partage de Ressources" className="form-check-input" />
                         <label className="form-check-label">Partage de Ressources</label>
                       </div>
                       <div className="form-check">
                         <Field type="checkbox" name="collaborationTypes" value="Développement de Projets Communs" className="form-check-input" />
                         <label className="form-check-label">Développement de Projets Communs</label>
                       </div>
                       <div className="form-check">
                         <Field type="checkbox" name="collaborationTypes" value="Autres" className="form-check-input" />
                         <label className="form-check-label">Autres</label>
                       </div>
                       <ErrorMessage name="collaborationTypes" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Avez-vous déjà collaboré avec d'autres organisations ?</label>
                       <Field as="textarea" name="previousCollaborations" className="form-control" />
                       <ErrorMessage name="previousCollaborations" component="div" className="text-danger" />
                     </div>

                     <div className="mb-3">
                       <label className="form-label">Principaux Projets Réalisés :</label>
                       <Field as="textarea" name="projects" className="form-control" />
                       <ErrorMessage name="projects" component="div" className="text-danger" />
                     </div>

                     <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                       Soumettre
                     </button>
                   </Form>
                 )}
               </Formik>
             </div>
           </div>
          </div>
      </section>

    </Layout>
  )
}
export default BecomePartner;